import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ValidationStatus } from 'signup-ui-lego-core/types';
import { setSignupDataCompleted, setSignupDataValue, setStepAsSkipped } from '../store/signup-data/action-creators';
import { getSignupDataErrorMessage, getSignupDataValidation, getSignupDataValue } from '../store/signup-data/selectors';
export const useSignupData = dataKey => {
  const dispatch = useDispatch();
  const data = useSelector(state => getSignupDataValue(state, dataKey));
  const validationState = useSelector(state => getSignupDataValidation(state, dataKey));
  const errorMessage = useSelector(state => getSignupDataErrorMessage(state, dataKey));
  const setData = useCallback(value => dispatch(setSignupDataValue(dataKey, value)), [dataKey, dispatch]);
  const setDataCompleted = useCallback(() => dispatch(setSignupDataCompleted(dataKey)), [dataKey, dispatch]);
  const setSkipped = useCallback(() => {
    dispatch(setStepAsSkipped(dataKey));
  }, [dispatch, dataKey]);
  return {
    data,
    setData,
    setDataCompleted,
    setSkipped,
    isValid: validationState === ValidationStatus.VALID,
    isInvalid: validationState === ValidationStatus.INVALID,
    errorMessage
  };
};